module.exports = __webpack_public_path__ + "ceba631eff9ae8078b4cb5e6c224e3d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/medias/images/data.png
// module id = 876
// module chunks = 3